import service from '@/store/services/account-activation-service';

const state = {
    data: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, data) => {
        state.data = data;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    checkActivationUrl({ commit, dispatch }, params) {
        return service.checkActivationUrl(params)
            .then((data) => { commit('SET_RESOURCE', data); });
    },

    sendSmsCode({ commit, dispatch }, params) {
        return service.sendSmsCode(params)
            .then((data) => { commit('SET_RESOURCE', data); });
    },

    checkSmsCode({ commit, dispatch }, params) {
        return service.checkSmsCode(params)
            .then((data) => { commit('SET_RESOURCE', data); });
    },

    activateUserSetPwd({ commit, dispatch }, params) {
        return service.activateUserSetPwd(params)
            .then((data) => { commit('SET_RESOURCE', data); });
    },
};

const getters = {
    data: state => state.data
};

const accountActivation = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default accountActivation;